import { useCallback } from 'react';

import { useSettingsStore } from '@blocks/stores/settings';
import { SubmitConfig } from '@blocks/types';

type UseOnSubmitArgs<T> = {
  domain: string;
  onSubmit: (config: SubmitConfig) => (values: T) => void;
  onSignIn?: (props: unknown) => void;
  setLoading: (loading: boolean) => void;
  [key: string]: unknown;
};

/**
 * XXX dynamic submit handler (depends on api data)
 */
const useOnSubmit = <T>(args: UseOnSubmitArgs<T>) => {
  const { onSubmit, domain, ...rest } = args;
  const { settings, client_utc_offset_min } = useSettingsStore(domain);
  const { env: { recaptcha_site_key } = {} } = settings || {};
  const submitHandler = useCallback(
    (values: T) => {
      if (recaptcha_site_key && client_utc_offset_min !== undefined) {
        return onSubmit({
          recaptcha_site_key,
          utc_offset_min: client_utc_offset_min,
          domain,
          ...rest,
        })(values);
      }
    },
    [recaptcha_site_key, client_utc_offset_min, onSubmit, domain, rest],
  );

  return submitHandler;
};

export default useOnSubmit;
